import React, { Component } from 'react';
import { WaypointLoader } from './components/waypoint-loader';
import { Spinner } from 'js/academia_components/transients/spinner';
import { ReaderCard } from './components/reader_card';
import {
  currentAnalyticsTab,
  trackAnalyticsClick,
  watchAnalyticsImpression,
} from 'js/analytics/metrics/analyticsTracking';

class Cards extends Component {
  constructor(props) {
    super(props);
    this.renderCard = this.renderCard.bind(this);
    this.state = {
      worksCount: null,
    };
  }

  componentDidMount() {
    this.props.fetchProfileVisitorCards();
    const worksCountUrl = $r.count_api_v0_user_works_path({
      subdomain_param: 'api',
      user_id: Aedu.User.current.id,
    });

    $.ajax({
      url: worksCountUrl,
      type: 'GET',
      dataType: 'json',
      success: (x) => this.setState({ worksCount: x.count }),
    });
  }

  componentWillUnmount() {
    this.emptyStateUploadWatcher?.stop();
  }

  emptyStateUploadRef = (element) => {
    if (element === this.emptyStateUploadElement) return;
    this.emptyStateUploadWatcher?.stop();
    this.emptyStateUploadWatcher = null;
    this.emptyStateUploadElement = element;
    if (element) {
      this.emptyStateUploadWatcher = watchAnalyticsImpression(
        element,
        'analytics-empty-state-upload',
        'profile_visitor_cards',
        { tab: currentAnalyticsTab() },
      );
    }
  };

  renderCard(cardData, index) {
    const onProfileClick = () =>
      trackAnalyticsClick(
        'analytics-content-link',
        { link_type: 'profile', table: 'profile_visitors' },
        Number.isInteger(cardData.reader.id) ? cardData.reader.id : undefined,
      );
    const onTitleClick = (linkType, entityId) =>
      trackAnalyticsClick(
        'analytics-content-link',
        { link_type: linkType, table: 'profile_visitors' },
        entityId,
      );
    const readerCardProps = {
      anon: true,
      ...cardData,
      onProfileClick,
      onTitleClick,
    };

    if (index === this.props.cards.length - 4) {
      return (
        <div key={cardData.reader.id}>
          <WaypointLoader
            {...this.props.meta}
            fetcher={() => this.props.fetchProfileVisitorCards()}
          />
          <ReaderCard {...readerCardProps} />
        </div>
      );
    }
    return <ReaderCard {...readerCardProps} key={cardData.reader.id} />;
  }

  render() {
    const { props } = this;

    if (props.cards && props.cards.length > 0) {
      return (
        <div className="DesignSystem">
          <div className="u-mh4x u-mv12x">
            <div>{props.cards.map(this.renderCard)}</div>

            <div>
              <Spinner show={props.meta.fetching} />
            </div>
          </div>
        </div>
      );
    } else if (
      !props.meta.exhausted &&
      props.cards &&
      props.cards.length === 0
    ) {
      return (
        <div className="DesignSystem">
          {' '}
          <Spinner show />{' '}
        </div>
      );
    }

    let uploadButtonText;
    if (this.state.works_count !== null) {
      if (this.state.worksCount === 0) {
        uploadButtonText = 'Upload a paper';
      } else {
        uploadButtonText = 'Keep uploading papers';
      }

      return (
        <div className="DesignSystem">
          <div className="u-mb24x u-pb24x">
            <div className="u-taCenter u-fs24 u-tcGrayDark u-p8x u-m0x">
              There are no available profile visitors.
            </div>
            <div className="u-taCenter u-fs20 u-tcGrayDark">
              <a
                className="u-tcGreen u-clickable"
                href="/Papers/Upload"
                ref={this.emptyStateUploadRef}
                onClick={() =>
                  trackAnalyticsClick('analytics-empty-state-upload', {
                    tab: currentAnalyticsTab(),
                  })
                }
              >
                {uploadButtonText}
              </a>
              <span>
                {' '}
                and we'll notify you when you receive a new profile visitor.
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="DesignSystem">
        {' '}
        <Spinner show />{' '}
      </div>
    );
  }
}

export default Cards;
